// extracted by mini-css-extract-plugin
export default {"container":"TF-z","header":"UF-z","details":"VF-z","link":"WF-z"};